// extracted by mini-css-extract-plugin
module.exports = {"form":"ProfileForm_form__2xGgc","control":"ProfileForm_control__2YUZH","green":"ProfileForm_green__2mcN1","action":"ProfileForm_action__opJ_6"};